import type {
  AuthAuth0SettingsSchema,
  AuthGenericSettingsSchema,
  AuthIdentityProviderSchema,
  AuthOktaSettingsSchema,
  AuthOneloginSettingsSchema,
} from '@iconik-io/iconik-api/src/services/auth';

import type { SelectOption } from '../../ui/select_field/types';

export type AuthIdentityProviderType = AuthIdentityProviderSchema['type'];

export const SAML_IDENTITY_PROVIDER_TYPE_ONELOGIN = 'onelogin.com';
export const SAML_IDENTITY_PROVIDER_TYPE_AUTH0 = 'auth0.com';
export const SAML_IDENTITY_PROVIDER_TYPE_OKTA = 'okta.com';
export const SAML_IDENTITY_PROVIDER_TYPE_GENERIC = 'GENERIC';

export const providerOptions: SelectOption[] = [
  { label: 'AUTH0', value: SAML_IDENTITY_PROVIDER_TYPE_AUTH0 },
  { label: 'GENERIC', value: SAML_IDENTITY_PROVIDER_TYPE_GENERIC },
  { label: 'OKTA', value: SAML_IDENTITY_PROVIDER_TYPE_OKTA },
  { label: 'ONELOGIN', value: SAML_IDENTITY_PROVIDER_TYPE_ONELOGIN },
];

/**
 * The new-provider form holds one flat bag of settings. Which fields matter
 * depends on the provider type the user picked, and the two are separate state,
 * so every field is optional here.
 */
export type IdentityProviderSettings = Partial<
  AuthAuth0SettingsSchema &
    AuthGenericSettingsSchema &
    AuthOktaSettingsSchema &
    AuthOneloginSettingsSchema
>;
